import { AMLCheckClient } from "../../../../../../Wrap/Api/Customer/AMLCheck";

export class AMLCheckACtion {
    public static getAmlCheck(customerId: number, callback) {
        const client = new AMLCheckClient();
        const promise = client.post(customerId, 0);
        promise.onSuccess((res) => {
            if (callback) {callback(res);}
        });

        promise.onError(() => {
            if (callback) {callback("An error occured");}
        });
    }
}
